export default __webpack_public_path__ + "static/media/ic-close.e849de27.svg";